var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconActiveHeart15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 16.190476",
    id: "svg14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs18"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-0.96,0.8335713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone/PlayScreenV2/Pause",
    transform: "translate(-363,-509)",
    fill: "#fa50c4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(363,507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Active/Heart",
    transform: "translate(0.96,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18.567234,9.8236266 -1.174398,1.1456404 -3.92249,3.895178 -3.45273,3.391095 L 6.5648855,14.864445 6.5179096,14.818619 5.1321198,13.466763 1.4445097,9.8694523 c -1.92601293,-1.8788504 -1.92601293,-4.926254 0,-6.8051043 0.9160305,-0.8935995 2.1374046,-1.3747685 3.4762184,-1.3747685 1.26835,0 2.5367,0.5040818 3.4762185,1.3747685 L 10.017616,4.6453318 11.638285,3.064348 c 0.916031,-0.8935995 2.160893,-1.3976813 3.476219,-1.3976813 1.315326,0 2.560188,0.5040818 3.476218,1.3976813 C 19.506753,3.9579476 20,5.1494136 20,6.4554437 20,7.738561 19.483265,8.9300271 18.567234,9.8236266 Z",
    id: "Heart"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActiveHeart15X);
export default __webpack_public_path__ + "static/media/Icon_Active_Heart@1_5x.20439687b7d17d94b95686801c98db98.svg";
export { ForwardRef as ReactComponent };